import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * @deprecated please do not to use this constant for any new code.
 * As part of pagination work https://product-fabric.atlassian.net/browse/RAGE-60
 * Send message without the agentId and it will be automatically routed to the default AI Mate agent in convo-ai.
 *
 * To remove, please check the comment in https://product-fabric.atlassian.net/browse/RAGE-418
 */
export const DEFAULT_AGENT: Agent = {
	id: 'ai_mate_agent',
	named_id: 'ai_mate_agent',
	name: 'AI Mate',
	description: 'AI Mate',
	creator_type: 'SYSTEM',
	available_plugins: {},
	is_default: true,
	visibility: 'PUBLIC',
	actor_type: 'AGENT',
	user_defined_conversation_starters: [],
	favourite: false,
	deactivated: false,
};
